/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StandingSmallList = {
    type: 'array',
    contains: {
        type: 'StandingSmall',
    },
} as const;
